import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content — Event Chauffeur (golden pattern: PR #250/#251/#252/#253). Authored FRENCH content
// from existing Content-Platform blocks + VERIFIED facts already live on site:
//   - transport événementiel / événements professionnels et privés : séminaires, conférences, soirées
//     (locales: services.events "Séminaires, conférences et soirées privées" + events.description + legal list6)
//   - chauffeur privé premium, ponctualité, discrétion, confort, online booking, price-before-booking, SAB area
// OPERATIONAL-RISK GUARD: this is a TRANSPORT page — driving the client to/from their events. It makes
// NO event-planning / event-coordination / guest-management / multi-driver / fleet-size / VIP-security /
// concierge / guaranteed-availability / dedicated-chauffeur / venue-partnership / exact-price claims.
// "Chauffeur dédié" (site wording) deliberately NOT reused. Vehicles BRAND-NEUTRAL. No fabricated
// claims. CTA offers book OR contact (/reserver + /contact). Mesh derived from the ratified catalogue.

const SLUG = 'event-chauffeur';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Chauffeur pour vos événements à Nantes',
      lead:
        'Un chauffeur privé pour vos séminaires, conférences et soirées à Nantes et en Loire-Atlantique — ponctuel, discret et au prix connu à l’avance.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte assure le transport de vos événements professionnels et privés à Nantes et en Loire-Atlantique — séminaires, conférences et soirées — avec des véhicules haut de gamme, un service ponctuel et discret, réservable en ligne.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi réserver un chauffeur pour votre événement',
      body: [
        'Lors d’un événement, chaque arrivée compte. Un chauffeur privé vous conduit à l’heure à votre séminaire, votre conférence ou votre soirée, sans gérer le stationnement ni l’itinéraire, et vous reprend en charge pour un retour serein.',
        'Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret — pour une arrivée à la hauteur de l’occasion. Le prix vous est communiqué avant la réservation.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un service à la hauteur de vos événements',
      items: [
        { title: 'Ponctualité', text: 'Une arrivée à l’heure à votre séminaire, votre conférence ou votre soirée.' },
        { title: 'Discrétion', text: 'Un service professionnel et confidentiel, adapté aux événements privés comme professionnels.' },
        { title: 'Confort', text: 'Un véhicule haut de gamme, calme et soigné, pour chacun de vos trajets.' },
        { title: 'Réservation simple', text: 'Réservez en ligne en quelques minutes, avec un prix connu à l’avance.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre transport événementiel',
      steps: [
        { title: 'Indiquez votre événement', text: 'Précisez vos adresses, la date et l’heure de votre séminaire, conférence ou soirée.' },
        { title: 'Obtenez votre prix', text: 'Votre tarif vous est communiqué avant de confirmer la réservation.' },
        { title: 'Réservez ou contactez-nous', text: 'Validez en ligne, ou contactez-nous pour un besoin particulier.' },
        { title: 'Votre chauffeur vous accompagne', text: 'Votre chauffeur vous prend en charge à l’heure, à l’aller comme au retour.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Vos événements à Nantes et en Loire-Atlantique',
      body: [
        'Séminaires d’entreprise, conférences, soirées privées ou occasions spéciales : Black Matte assure les trajets liés à vos événements, à Nantes et dans toute la Loire-Atlantique.',
        'Notre service couvre Nantes et sa région, ainsi qu’Angers, Rennes et La Roche-sur-Yon, 24h/24 et 7j/7, avec des chauffeurs privés professionnels et discrets.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre chauffeur pour votre événement',
      text: 'Réservez votre chauffeur privé pour votre événement, ou contactez-nous pour votre transport événementiel.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Nous contacter', to: '/contact' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
